import type {
  LeaderboardTriviaAnswerResult,
  LeaderboardTriviaPending,
} from '../../../domain/leaderboard/models/leaderboard-trivia.model';

/** Demo trivia for mock / local runs (correct answer: B). */
export function createStubLeaderboardTriviaPending(overrides?: Partial<LeaderboardTriviaPending>): LeaderboardTriviaPending {
  return {
    day: 1,
    xpAwarded: 25,
    question: '¿Cuál es la capital de Colombia?',
    options: [
      { letter: 'A', label: 'Medellín' },
      { letter: 'B', label: 'Bogotá' },
      { letter: 'C', label: 'Cali' },
      { letter: 'D', label: 'Cartagena' },
    ],
    ...overrides,
  };
}

export function gradeStubTriviaAnswer(
  trivia: LeaderboardTriviaPending,
  answer: string,
): LeaderboardTriviaAnswerResult {
  const normalized = answer.trim().toUpperCase();
  const correct = normalized === 'B';
  return {
    correct,
    xpAwarded: correct ? trivia.xpAwarded : 0,
    day: trivia.day,
  };
}
